<template>
  <teleport v-if="targetElement" :to="targetElement">
    <menu
      class="net-actionbar"
      @pointerdown.stop=""
      @keydown="onKeydown"
      @wheel="onMouseWheel"
      :style="{
        left: `${Math.max(0, Math.round(viewportCoordinates.x))}px`,
        top: `calc(${Math.max(40, Math.round(viewportCoordinates.y))}px - 3rem)`
      }"
      v-bind="$attrs"
    >
      <slot></slot>
    </menu>
  </teleport>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useCanvasDimensions } from "./useCanvasDimensions";

defineOptions({
  inheritAttrs: false
});
const props = withDefaults(defineProps<{
  x: number;
  y: number;
  width?: number;
  height?: number;
}>(), {
  x: 0,
  y: 0,
  width: 0,
  height: 0
});

const emit = defineEmits<{
  (e: "wheel", event: WheelEvent): void;
}>();

const { netId, toViewportComputed } = useCanvasDimensions();
const viewportCoordinates = toViewportComputed(() => ({ x: props.x, y: props.y }));

// Get the net container to teleport the actionbar to
const targetElement = ref<HTMLElement | null>(null);
setTimeout(() => {
  targetElement.value = document.querySelector(`#${netId.value}`);
}, 1);

function onKeydown(event: KeyboardEvent){
  if ((event.key == "+" || event.key == "-") && (event.ctrlKey || event.metaKey)) {
    event.preventDefault();
    console.log("zoom");
  } 
}

function onMouseWheel(event: WheelEvent) {
  if (event.metaKey || event.ctrlKey) {
    event.preventDefault();
  }
  emit("wheel", event);
}
</script>

<style lang="scss">
.net-actionbar {
  position: absolute;
  // left: 0;
  // bottom: calc(100% + 0.5em);
  width: max-content;
  min-width: min-content;

  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;

  background-color: var(--color-background-close);
  box-shadow: 0 0.05em 0.25em var(--color-shadow-2);
  pointer-events: all;

  --h: 2.5rem;

  .dark & {
    --active-bg-color: hsl(var(--color-primary-h), 80%, 17%);
    --active-bg-color-hover: hsl(var(--color-primary-h), 80%, 20%);
  }

  &__entry {
    padding: 0;
    min-width: var(--h);
    height: var(--h);
  }
  &__button {
    --active-bg-color: hsl(var(--color-primary-h), 80%, 94%);
    --active-bg-color-hover: hsl(var(--color-primary-h), 80%, 90%);
    position: relative;
    appearance: none;
    font-family: inherit;
    background-color: transparent;
    width: 100%;
    border: none;
    height: var(--h);
    padding: 0.5rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: var(--font-size-button);
    font-size: 16px;
    z-index: 0;

    &.-active {
      background-color: var(--active-bg-color);
    }

    &.-light {
      color: var(--color-text-medium);
      font-size: 14px;
      background-color: rgba(var(--tint-contrast), 0.01);
    }
  }

  &__input {
    border: none;
    box-shadow: none;
    border-radius: 0;
    position: relative;
    font-size: 16px;
    height: 100%;
  }

  &__input::after,
  &__button::after {
    content: "";
    display: block;
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: transparent;
    z-index: 0;
  }

  &__button > *,
  &__input > * {
    position: relative;
    z-index: 1;
  }

  &__button:hover::after,
  &__input:hover::after {
    background-color: rgba(var(--tint-contrast), 0.02);
  }
  &__button:active::after,
  &__input:active::after {
    background-color: rgba(var(--tint-contrast), 0.05);
  }
  &__button:hover.-active::after {
    background-color: var(--active-bg-color-hover);
  }

  &__uploadbutton {
    position: relative;
    padding: 0;
    & > input {
      position: absolute;
      left: 0;
      top: 0;
      pointer-events: none;
      opacity: 0;
    }
  }

  & > .separator {
    display: block;
    flex-shrink: 0;
    width: 1px;
    align-self: stretch;
    border-top: none;
    background-color: black;
    border-left: 1px solid var(--color-border-light);
  }
}
</style>
